import React, { useCallback, useEffect, useState } from "react";
import { Form, Row, Col, Button, Container } from "react-bootstrap";
import { FormGroup, Input, Label } from "reactstrap";
import { Redirect, useHistory, Link } from "react-router-dom";
import { UserConsumer } from "../../../../UserContext";
import axios from "axios";
import { ItemRequisitionAPI } from "../ItemRequisitionAPI";
import { debounce } from "lodash";
import { LongTrimString, tableStyle } from "../../../../components/TableStyle";
import { Table } from "../../../../components/CustomPaginations";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import CustomReactSelect from "../../../../components/CustomReactSelect";
import Edit from "../../../../images/edit.svg";
import Header from "../../../../components/Header";
import CustomeSearchBar from "../../../../components/CustomeSearchBar";
import { AlertPopups } from "../../../../components/AlertPopups";
import { Routes } from "../../../../configurations/config";
import {
	GlobalPaginationSize,
	getPaginationSizeOnRole,
} from "../../../../components/GlobalPaginationSize";

const ItemRequisitionCategories = () => {
	const history = useHistory();
	let token,
		empDesignation = null;
	const initialValues = {
		code: "",
		name: "",
		className: "",
		latestUsedCode: "",
		description: "",
		status: false,
	};
	const defaultSorted = [
		{
			dataField: "name",
			order: "asc",
		},
	];
	const [categoriesList, setCategoriesList] = useState([]);
	const [createCategory, setCreateCategory] = useState(initialValues);
	const [activeCategories, setActiveCategories] = useState([]);
	const [categoryId, setCategoryId] = useState(null);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(
		GlobalPaginationSize.defaultPaginationSize
	);
	const [isLoaded, setIsLoaded] = useState(true);
	const [pagerData, setPagerData] = useState(null);
	const [sortBy, setSortBy] = useState(defaultSorted[0]);
	const [updateRecord, setUpdateRecord] = useState(false);
	const [searchInput, setSearchInput] = useState("");

	useEffect(() => {
		const pageSize = getPaginationSizeOnRole(empDesignation);
		setNumberOfItemsPerPage(pageSize);

		getCategoryList();
		getActiveCategories();
	}, []);

	const getColumns = [
		{
			dataField: "name",
			text: "Name",
			 title: true ,
			sort: true,
			formatter: LongTrimString,
		},
		{
			dataField: "code",
			text: "Code",
			sort: true,
		},
		{
			dataField: "className",
			text: "Class",
			sort: true,
			formatter: LongTrimString,
		},
		{
			dataField: "description",
			text: "Description",
			 title: true ,
			sort: true,
			formatter: LongTrimString,
		},
		{
			dataField: "status",
			text: "Status",
			formatter: (status) => {
				return status ? "Active" : "Inactive";
			},
		},
		{
			dataField: "action",
			text: "Action",
			formatter: (cell, row) => {
				return (
					<div style={{ textAlign: "center" }}>
						<Link
							to={Routes.ItemRequisitionCategories}
							onClick={() => {
								getCategoryId(row.id);
							}}
						>
							<img
								style={{ height: "20px", width: "20px" }}
								src={Edit}
								alt="Edit"
								title="Modify Category"
							/>
						</Link>
					</div>
				);
			},
		},
	];

	const getCategoryList = (searchTerm = "") => {
		setSearchInput(searchTerm.trimStart());

		setIsLoaded(true);
		axios
			.get(
				`${
					ItemRequisitionAPI.GetItemRequisitionCategories
				}?PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${
					sortBy.order
				}${searchTerm ? "&SearchTerm=" + searchTerm.trimStart() : ""}`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then(({ data, headers }) => {
				setIsLoaded(false);
				setPagerData(JSON.parse(headers["x-pagination"]));
				setCategoriesList(data["categories"]);
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: `${err.response.data.message}`,
					});
				}
			});
	};
	const handleChange = (e) => {
		setCreateCategory({
			...createCategory,
			[e.target.name]: e.target.value,
		});
	};
	const handleReset = () => {
		setCreateCategory(initialValues);
	};
	const getActiveCategories = () => {
		axios
			.get(`${ItemRequisitionAPI.GetActiveClasses}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then(({ data }) => {
				setActiveCategories(data["activeClasses"]);
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: `${err.response.data.message}`,
					});
				}
			});
	};
	const handleSubmit = () => {
		if (createCategory.name === "") {
			AlertPopups.ErrorAlert.fire({
				text: "Please Enter the Name",
			});

			return;
		}
		if (createCategory.code === "") {
			AlertPopups.ErrorAlert.fire({
				text: "Please Enter the Code",
			});

			return;
		}
		if (createCategory.className === "") {
			AlertPopups.ErrorAlert.fire({
				text: "Please Enter the Class",
			});

			return;
		}
		const body = {
			classID: createCategory.className,
			name: createCategory.name,
			code: createCategory.code,
			lastUsedCode: createCategory.latestUsedCode,
			description: createCategory.description,
			status: createCategory.status,
		};
		axios
			.post(`${ItemRequisitionAPI.GetItemRequisitionCategories}`, body, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then(() => {
				AlertPopups.successAlert.fire({
					text: "Success",
				});

				getCategoryList();
				setCreateCategory(initialValues);
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: `${err.response.data.message}`,
					});
				}
			});
	};
	const getCategoryId = (id) => {
		setCategoryId(id);
		setUpdateRecord(true);
		axios
			.get(`${ItemRequisitionAPI.GetItemRequisitionCategories}/${id}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then(({ data }) => {
				setCreateCategory({
					name: data.name,
					code: data.code,
					latestUsedCode: data.lastUsedCode,
					description: data.description,
					className: data.classID,
					status: data.status,
				});
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: `${err.response.data.message}`,
					});
				}
			});
	};

	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		setIsLoaded(true);
		let apiURL = "";

		if (type === "sort") {
			apiURL = `${ItemRequisitionAPI.GetItemRequisitionCategories}?PageNumber=${page}&PageSize=${numberOfItemsPerPage}&SortBy=${sortField}_${sortOrder}`;
			setSortBy({ dataField: sortField, order: sortOrder });
		} else {
			apiURL = `${ItemRequisitionAPI.GetItemRequisitionCategories}?PageNumber=${page}&PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}`;
		}
		if (page !== undefined) {
			axios
				.get(apiURL, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then((res) => {
					if (res.status === 200) {
						setIsLoaded(false);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setCategoriesList(res.data["categories"]);
					}
				})
				.catch((err) => {
					if (err.response) {
						AlertPopups.ErrorAlert.fire({
							text: `${err.response.data.message}`,
						});
					}
				});
		}
	};
	const receiveData = (PageSize) => {
		setIsLoaded(true);
		let apiURL = "";

		apiURL = `${
			ItemRequisitionAPI.GetItemRequisitionCategories
		}?PageNumber=${1}&PageSize=${PageSize}`;
		axios
			.get(apiURL, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then((res) => {
				if (res.status === 200) {
					setIsLoaded(false);
					setNumberOfItemsPerPage(PageSize);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setCategoriesList(res.data["categories"]);
				}
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: `${err.response.data.message}`,
					});
				}
			});
	};

	const handleUpdate = () => {
		if (createCategory.name === "") {
			AlertPopups.ErrorAlert.fire({
				text: "Please Enter the Name",
			});

			return;
		}
		if (createCategory.code === "") {
			AlertPopups.ErrorAlert.fire({
				text: "Please Enter the Code",
			});

			return;
		}
		const body = {
			classID: createCategory.className,
			name: createCategory.name,
			code: createCategory.code,
			lastUsedCode: createCategory.latestUsedCode,
			description: createCategory.description,
			status: createCategory.status,
		};
		axios
			.put(
				`${ItemRequisitionAPI.GetItemRequisitionCategories}/${categoryId}`,
				body,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			.then(() => {
				AlertPopups.successAlert.fire({
					text: "Category Updated Successfully",
				});

				setSearchInput(" ");
				getCategoryList();
				handleReset();
				setUpdateRecord(false);
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: `${err.response.data.message}`,
					});
				}
			});
	};
	const debounceSearch = useCallback(debounce(getCategoryList, 500), []);
	const searchOnChange = (e) => {
		debounceSearch(e.target.value);
	};
	const rowEvents = {
		onClick: (e, row) => {
			getCategoryId(row.id);
			history.push({
				pathname: `${Routes.ItemRequisitionCategories}`,
			});
		},
	};

	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				empDesignation = userDetails.designation;
				return userDetails.id.toString() === "40" ||
					userDetails.id.toString() === "33" ||
					userDetails.empRole.includes("3") ? (
					<Container fluid className="mt-3">
						<Header
							title="Categories"
							headerBorder="true"
							navigateBack={() =>
								history.push(Routes.ItemRequisition)
							}
						/>
						<Form className="item-requisition-classes-form">
							<Label className="formInfoContainerHeader">
								Enter Category Details
							</Label>
							<Row className="d-flex align-items-center item-requisition-classes-fbody">
								<Col lg={4}>
									<FormGroup className="category-form-group">
										<Label className="mr-3 form-lable">
											Code
											<span className="required">*</span>
										</Label>
										<Input
											type="number"
											name="code"
											required
											onChange={handleChange}
											value={createCategory.code}
											className="category-inputs h-auto formValueInput"
										/>
									</FormGroup>
								</Col>
								<Col lg={4}>
									<FormGroup className="category-form-group ">
										<Label className="mr-3 form-lable">
											Name
											<span className="required">*</span>
										</Label>
										<Input
											type="text"
											name="name"
											required
											onChange={handleChange}
											value={createCategory.name}
											className="category-inputs h-auto formValueInput"
										/>
									</FormGroup>
								</Col>
								<Col lg={4}>
									<FormGroup className="category-form-group ">
										<Form.Label className="mr-3 form-lable">
											Class
											<span className="required">*</span>
										</Form.Label>
										<div className="classes-dropDown">
											<CustomReactSelect
												className="classes-select h-auto formValueInput"
												options={activeCategories}
												value={activeCategories.filter(
													(item) =>
														item.value ==
														createCategory.className
												)}
												onChange={(e) =>
													setCreateCategory({
														...createCategory,
														className: e.value,
													})
												}
											/>
										</div>
									</FormGroup>
								</Col>
								<Col lg={4}>
									<Form.Group className="category-form-group ">
										<Form.Label className="mr-3 form-lable">
											Description
											<span className="required">*</span>
										</Form.Label>
										<Form.Control
											as="textarea"
											rows={2}
											name="description"
											onChange={handleChange}
											value={createCategory.description}
											className="category-inputs formValueInput"
										/>
									</Form.Group>
								</Col>
								<Col lg={4}>
									<Form.Group
										className="category-form-group"
										style={{ justifyContent: "flex-start" }}
									>
										<Form.Label className="mr-3 form-lable">
											Active
										</Form.Label>
										<Form.Control
											type="checkbox"
											name="status"
											checked={createCategory.status}
											onChange={() => {
												setCreateCategory({
													...createCategory,
													status: !createCategory.status,
												});
											}}
											className="category-inputs formValueInput"
										/>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								{!updateRecord ? (
									<Col>
										<Button
											className="classes-resetBtn"
											onClick={handleReset}
										>
											Reset
										</Button>
										<Button
											className="classes-saveBtn"
											onClick={handleSubmit}
										>
											Create
										</Button>
									</Col>
								) : (
									<Col>
										<Button
											className="classes-resetBtn"
											onClick={() => {
												setUpdateRecord(false);
												handleReset();
											}}
										>
											Undo
										</Button>
										<Button
											className="classes-updateBtn"
											onClick={handleUpdate}
										>
											Update
										</Button>
									</Col>
								)}
							</Row>
						</Form>
						<CustomeSearchBar
							inputValue={searchInput}
							handleSearch={(event) => searchOnChange(event)}
							tooltip={
								"Search by token, name, requested by and status"
							}
						/>

						{pagerData ? (
							<PaginationProvider
								pagination={paginationFactory({
									custom: true,
									totalSize: categoriesList.length,
									page: pagerData?.CurrentPage,
									sizePerPage: pagerData?.PageSize,
									paginationSize: pagerData?.PageSize,
								})}
							>
								{({
									paginationProps,
									paginationTableProps,
								}) => {
									return (
										<Table
											inputValue={searchInput}
											keyField={"id"}
											columns={getColumns}
											items={categoriesList}
											tableStyle={tableStyle}
											paginationProps={paginationProps}
											paginationTableProps={
												paginationTableProps
											}
											onTablePageChange={
												handleTableChange
											}
											defaultSorted={defaultSorted}
											pagerData={pagerData}
											showFeedback={false}
											tableLoader={isLoaded}
											SearchBar={() => {
												return null;
											}}
											receiveData={(PageSize) => {
												receiveData(PageSize);
											}}
											rowEvents={rowEvents}
										/>
									);
								}}
							</PaginationProvider>
						) : (
							<Table
								inputValue={""}
								keyField={"name"}
								columns={getColumns}
								items={categoriesList}
								tableStyle={tableStyle}
								defaultSorted={sortBy}
								showFeedback={false}
								tableLoader={isLoaded}
								SearchBar={() => {
									return null;
								}}
							/>
						)}
					</Container>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
};

export default ItemRequisitionCategories;
